import { Select } from "antd";
import { SelectComPesquisa } from "../../../SelectComPesquisa";
import { useListar } from "../../../../Services/Pessoa/PessoaTipo";
import { EnumPessoaTipo } from "../../../../Models/Pessoa/Pessoa";
import { useEffect } from "react";

interface IPessoaTipoSelectProps extends Omit<React.ComponentProps<typeof Select>, | "showSearch" | "optionFilterProp" | "filterOption"> {
    tiposPessoaValidos?:number[]|EnumPessoaTipo[],
    tiposPessoaInValidos?:number[]|EnumPessoaTipo[]
}

export default function PessoaTipoSelect({
    placeholder,
    allowClear,
    tiposPessoaValidos,
    tiposPessoaInValidos,
    onChange,
    value,
    ...rest
}:IPessoaTipoSelectProps) {
    const {
        data,
        isLoading,
        isSuccess
    } = useListar({
        ativo : true,
        tiposPessoaValidos,
        tiposPessoaInValidos
    });

    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder ?? "Selecione"}
        allowClear={allowClear ?? true}
        loading={isLoading}
        onChange={onChange}
        value={value}
        options={(data ?? []).map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    />
}